import theme from '../../common/styles/theme'

export default {
  ...theme,
}
